import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { DatePickerModule, DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { MaterialModule } from '../../../../@fuse/material.module';
import { AlertMessageModelComponent } from './alert-message-model.component';
@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    TranslateModule,
    KeyboardShortcutsModule.forRoot(),
    FormsModule,
    MatDatepickerModule,
    DatePickerModule, DateTimePickerModule
  ],
  exports: [AlertMessageModelComponent],
  declarations: [AlertMessageModelComponent]
})
export class AlertMessageModelModule { }
